var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("基本信息")))])]), _c("a-form-model", {
    ref: "ruleForm",
    attrs: {
      model: _vm.form,
      rules: _vm.rules,
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 10
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("承保单位"),
      prop: "unitId"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("承保单位"),
      disabled: ""
    },
    model: {
      value: _vm.form.unitId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "unitId", $$v);
      },
      expression: "form.unitId"
    }
  }, _vm._l(_vm.unitList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("机构全称"),
      prop: "name"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("机构全称")
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("机构级别"),
      prop: "level"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("机构级别")
    },
    model: {
      value: _vm.form.level,
      callback: function ($$v) {
        _vm.$set(_vm.form, "level", $$v);
      },
      expression: "form.level"
    }
  }, _vm._l(_vm.agencyLevelList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("投保提醒")
    }
  }, [_c("div", {
    staticClass: "remind"
  }, [_c("a-textarea", {
    attrs: {
      maxLength: 500,
      rows: 4
    },
    on: {
      input: _vm.onChangeRemind,
      change: _vm.onChangeRemind
    },
    model: {
      value: _vm.form.insuranceReminder,
      callback: function ($$v) {
        _vm.$set(_vm.form, "insuranceReminder", $$v);
      },
      expression: "form.insuranceReminder"
    }
  }), _c("div", {
    staticClass: "insert"
  }, [_c("span", {
    staticStyle: {
      color: "rgba(0, 0, 0, 0.85)"
    }
  }, [_vm._v(_vm._s(_vm.$t("插入变量")) + "：")]), _c("div", {
    staticClass: "variable"
  }, [_c("div", {
    staticClass: "font"
  }, [_vm._v(_vm._s(_vm.$t("点击变量自动复制变量类型，可手动粘贴到模板内容")))]), _vm._l(_vm.remindList, function (item) {
    return _c("a-tag", {
      key: item.key,
      staticStyle: {
        cursor: "pointer"
      },
      attrs: {
        color: "blue"
      },
      on: {
        "!click": function ($event) {
          $event.stopPropagation();
          return _vm.handleCopy(`《${item.name}》`, $event);
        }
      }
    }, [_vm._v(" 《" + _vm._s(item.name) + "》 ")]);
  })], 2)])], 1)]), _vm.showRemind.length ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("配置变量"),
      prop: "remind"
    }
  }, _vm._l(_vm.showRemind, function (item, index) {
    return _c("div", {
      key: item.remind,
      staticClass: "has-remind"
    }, [_c("span", {
      staticClass: "marginR15"
    }, [_vm._v("《" + _vm._s(item.remind) + "》：")]), item.id ? _c("div", {
      staticStyle: {
        display: "flex",
        "flex-direction": "column"
      }
    }, [_c("span", [_c("span", {
      staticClass: "file-name"
    }, [_vm._v("《" + _vm._s(item.name) + "》 "), _c("a-icon", {
      staticStyle: {
        margin: "0 5px"
      },
      attrs: {
        type: "close"
      },
      on: {
        click: function ($event) {
          return _vm.delFile(item, index);
        }
      }
    })], 1)]), _c("span", [_vm._v(_vm._s(item.remark))])]) : _c("span", {
      staticClass: "pointer margin",
      on: {
        click: function ($event) {
          return _vm.onAddFile(index);
        }
      }
    }, [_vm._v("+ " + _vm._s(_vm.$t("添加文件")))])]);
  }), 0) : _vm._e(), _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("非实时投保（非必填项，可选择不配置）")))])]), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("保司邮箱"),
      "validate-status": _vm.email,
      help: _vm.email == "error" ? _vm.$t("请输入") + _vm.$t("正确的保司邮箱") : ""
    }
  }, [_c("a-input", {
    model: {
      value: _vm.form.email,
      callback: function ($$v) {
        _vm.$set(_vm.form, "email", $$v);
      },
      expression: "form.email"
    }
  })], 1), _c("a-form-model-item", {
    staticClass: "itemBox",
    attrs: {
      label: _vm.$t("抄送邮箱")
    }
  }, _vm._l(_vm.ccList, function (item, index) {
    return _c("div", {
      key: index
    }, [_c("a-input", {
      model: {
        value: item.cc,
        callback: function ($$v) {
          _vm.$set(item, "cc", $$v);
        },
        expression: "item.cc"
      }
    }), _c("div", {
      staticClass: "btn"
    }, [index == 0 ? _c("a-button", {
      staticClass: "select-bottom",
      attrs: {
        type: "add"
      },
      on: {
        click: _vm.handleAdd
      }
    }, [_vm._v(_vm._s(_vm.$t("新增")))]) : _vm._e(), index != 0 ? _c("a-button", {
      staticClass: "select-bottom",
      attrs: {
        type: "danger"
      },
      on: {
        click: function ($event) {
          return _vm.handleDel(index);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("删除")))]) : _vm._e()], 1)], 1);
  }), 0), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("发送日期"),
      "validate-status": _vm.cycleType,
      help: _vm.cycleType == "error" ? _vm.$t("请选择") + _vm.$t("发送日期") : ""
    }
  }, [_c("a-checkbox-group", {
    model: {
      value: _vm.cycle,
      callback: function ($$v) {
        _vm.cycle = $$v;
      },
      expression: "cycle"
    }
  }, [_c("a-checkbox", {
    attrs: {
      value: "1",
      name: "type"
    }
  }, [_vm._v(_vm._s(_vm.$t("周一")))]), _c("a-checkbox", {
    attrs: {
      value: "2",
      name: "type"
    }
  }, [_vm._v(_vm._s(_vm.$t("周二")))]), _c("a-checkbox", {
    attrs: {
      value: "3",
      name: "type"
    }
  }, [_vm._v(_vm._s(_vm.$t("周三")))]), _c("a-checkbox", {
    attrs: {
      value: "4",
      name: "type"
    }
  }, [_vm._v(_vm._s(_vm.$t("周四")))]), _c("a-checkbox", {
    attrs: {
      value: "5",
      name: "type"
    }
  }, [_vm._v(_vm._s(_vm.$t("周五")))])], 1)], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("发送时间"),
      "validate-status": _vm.sendAtType,
      help: _vm.sendAtType == "error" ? _vm.$t("请选择") + _vm.$t("发送时间") : ""
    }
  }, [_c("a-time-picker", {
    attrs: {
      valueFormat: "HH:mm:ss"
    },
    model: {
      value: _vm.form.sendAt,
      callback: function ($$v) {
        _vm.$set(_vm.form, "sendAt", $$v);
      },
      expression: "form.sendAt"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("投保模版"),
      "validate-status": _vm.templateUrlType,
      help: _vm.templateUrlType == "error" ? _vm.$t("请上传投保模版") : ""
    }
  }, [_c("a-upload", {
    attrs: {
      action: _vm.action,
      headers: _vm.headers,
      data: {
        module: "agencyTemplate"
      },
      accept: "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "file-list": _vm.fileList
    },
    on: {
      change: _vm.handleChange
    }
  }, [_c("a-button", [_vm._v(_vm._s(_vm.$t("上传模版")))]), _c("div", {
    staticStyle: {
      "font-size": "12px",
      "margin-top": "10px"
    }
  }, [_vm._v(" *" + _vm._s(_vm.$t("发送给保险公司模版"))), _c("br"), _vm._v("*" + _vm._s(_vm.$t("仅支持上传xlxs格式文件")) + " ")])], 1)], 1), _c("a-form-model-item", {
    attrs: {
      "wrapper-col": {
        span: 14,
        offset: 4
      }
    }
  }, [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t("确认")))])], 1)], 1), _c("a-modal", {
    attrs: {
      title: _vm.$t("添加文件"),
      width: 600,
      maskClosable: false
    },
    on: {
      cancel: function ($event) {
        _vm.fileVisible = false;
      }
    },
    model: {
      value: _vm.fileVisible,
      callback: function ($$v) {
        _vm.fileVisible = $$v;
      },
      expression: "fileVisible"
    }
  }, [_c("a-table", {
    attrs: {
      size: "small",
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.data,
      align: "center",
      rowKey: "id",
      pagination: false
    },
    scopedSlots: _vm._u([{
      key: "operation",
      fn: function (text, record, i) {
        return [_c("a-radio", {
          staticStyle: {
            "margin-right": "0px"
          },
          attrs: {
            checked: record.checked
          },
          on: {
            change: function ($event) {
              return _vm.onChangeFile(record, i);
            }
          }
        })];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.saveFile
    }
  }, [_vm._v(_vm._s(_vm.$t("确认")))])], 1)], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };